import { useSnackbar } from 'notistack';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as DataServices from '../services/notificaciones';

// GET ALL PAGINATION
export const useGetNotifications = (filters, options?) =>
  useQuery(['notificaciones'], () => DataServices.fetchAllPagination(filters), options);

// GET PAGINATION
export const useGetAllNotifications = (filters, options?) =>
  useQuery(['allNotificaciones'], () => DataServices.fetchAll(filters), options);

// // GET ONE CLIENT
// export const useGetOneClient = (usuCli, options?) =>
//   useQuery(['cliente'], () => DataServices.fetchCurrentClient(usuCli), options);

// CREATE NOTIFICATION
export const useCreateNotifications = () => {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  return useMutation((values) => DataServices.createData(values), {
    onSuccess: () => {
      queryClient.invalidateQueries(['notificaciones']);
      enqueueSnackbar('Creación existosa', { variant: 'success' });
    },
    onError: () => {
      enqueueSnackbar('Creación fallida', { variant: 'error' });
    },
  });
};

// UPDATE NOTIFICATION
export const useUpdateNotifications = () => {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  return useMutation(([id, values]) => DataServices.updateData(id, values), {
    onSuccess: () => {
      queryClient.invalidateQueries(['notificaciones']);
      enqueueSnackbar('Actualización existosa', { variant: 'success' });
    },
    onError: (err) => {
      enqueueSnackbar(err || 'Actualización fallida', { variant: 'error' });
    },
  });

  // return useMutation((values) => DataServices.updateData(values.cli_rut, values), {
  //   onMutate: async (data) => {
  //     await queryClient.cancelQueries(['cliente']);
  //     const previousData = queryClient.getQueryData(['cliente']);
  //     // queryClient.setQueryData(['camps'], (old) => [...old.filter((x) => x.id !== data.id), data]);
  //     queryClient.setQueryData(['notificaciones'], (old) => old);
  //     return { previousData };
  //   },
  //   onError: (err, data, context) => {
  //     console.log(err);
  //     queryClient.setQueryData(['notificaciones'], context.previousData);
  //     enqueueSnackbar('Error al actualizar.', { variant: 'error' });
  //   },
  //   onSettled: () => {
  //     enqueueSnackbar('Actualizado', { variant: 'success' });
  //     queryClient.invalidateQueries(['cliente']);
  //   },
  // });
};
